import { FILTER_TYPES } from '@urc-ui/utils/types';
import { CustomReportType } from '@urc-ui/store/api/report-metadata/types';
import { MRC_ACCREDITATION_STATUS_FILTER_VALUE_SIVT } from '@urc-ui/store/api/ross/constants/filter-constants';

export const isMRCEnabled = (customReportType: CustomReportType | null): boolean => {
  if (!customReportType) {
    return false;
  }
  return customReportType?.filterTypes.includes(FILTER_TYPES.MRC_ACCREDITATION_STATUS);
};

export const isMRCCheckboxSelected = (filters: any[]) => {
  const mrcFilter = filters?.find(filter => filter.id === FILTER_TYPES.MRC_ACCREDITATION_STATUS);
  return mrcFilter?.values[0]?.[FILTER_TYPES.MRC_ACCREDITATION_STATUS] === MRC_ACCREDITATION_STATUS_FILTER_VALUE_SIVT || false;
};
